window.addEventListener("load", () => {
    const sliders = document.querySelectorAll(".block-im-slider .swiper");

    for (const slider of sliders) {
        const prev_button = slider.querySelector(".swiper-button-prev");
        const next_button = slider.querySelector(".swiper-button-next");
        const pagination  = slider.querySelector(".swiper-pagination");

        new Swiper(slider, {
            slidesPerView: 1,
            loop: true,
            speed: 1000,
            effect: "creative",
            creativeEffect: {
                prev: {
                    shadow: true,
                    translate: ["-20%", 0, -1],
                },
                next: {
                    translate: ["100%", 0, 0],
                },
            },
            navigation: {
                prevEl: prev_button,
                nextEl: next_button
            },
            pagination: {
                el: pagination,
                type: "bullets",
                clickable: true
            },
            autoplay: {
                delay: 5000
            }
        });
    }
});
